/*
 * @Author: cmchiu
 * @Date: 2022-09-12 14:32:18
 * @LastEditTime: 2022-10-24 17:01:37
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\store\modules\user.js
 *
 */
import Auth from '@/api/auth'

const state = {
    isLogin: false,
    info: {},
}

const mutations = {
    SET_ISLOGIN: (state, isLogin) => {
        state.isLogin = isLogin
    },

    SET_USERINFO: (state, info) => {
        state.info = info
    },
}

const actions = {
    checkLogin({ commit }) {
        return new Promise((resolve, reject) => {
            Auth.isLogin()
                .then(isLogin => {
                    commit('SET_ISLOGIN', isLogin)
                    if (isLogin)
                        Auth.checkCampusIsLogged() // 產生LM API驗證用的cookie
                            .then(() => resolve(isLogin))
                    else
                        Auth.logoutLM() // 刪除LM API驗證用的cookie
                            .then(() => resolve(isLogin))
                    // resolve(isLogin)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

    getUserInfo({ commit }) {
        return new Promise((resolve, reject) => {
            if (state.isLogin) {
                Auth.getLogName()
                    .then(id => {
                        Auth.getAcpdById({ id })
                            .then(res => {
                                if (res.Code === 1) {
                                    commit('SET_USERINFO', {
                                        isLogin: state.isLogin,
                                        id: res.Items.Id,
                                        name: res.Items.Name,
                                        email: res.Items.Email,
                                        class: res.Items.Class,
                                    })
                                    resolve(res.Items)
                                }
                            })
                            .catch(error => {
                                reject(error)
                            })
                    })
                    .catch(error => {
                        reject(error)
                    })
            } else {
                commit('SET_USERINFO', {
                    isLogin: false,
                    id: '',
                    name: '',
                    email: '',
                    class: '',
                })
                resolve()
            }
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
